import styled from "styled-components";
import { BREAKPOINTS } from "../../../../app/appConstants";

export const MobileAppRegistrationStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 375px;
    margin: 0 auto;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        width: 100%;
        margin: 0;
    }
`;

export const MobileAppRegistrationContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    font-size: 16px;
    padding: 0 16px;
    width: 100%;
    
    input::placeholder {
        color: var(--color-label-secondary);
        opacity: 1;
    }
    
    .select-country__toggle-label {
        color: var(--color-label-secondary);
    }
    .select-country__arrow-icon {
        fill: var(--color-label-secondary);
    }
`;
